module.exports = __webpack_public_path__ + "static/media/winter-che-small-mobile.65457d54.png";